module.exports = __webpack_public_path__ + "staticcomp/img/top.1ad4e8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/10/top.jpg
// module id = 0i4C
// module chunks = 39